// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const env = import.meta.env;
export default {
  CONFIGURATION_ENDPOINT: env['VITE_CONFIGURATION_ENDPOINT'],
  CLIENT_ID: env['VITE_CLIENT_ID'],
  TID_REDIRECT_URL: env['VITE_TID_REDIRECT_URL'],
  TID_LOGOUT_REDIRECT_URL: env['VITE_TID_LOGOUT_REDIRECT_URL'],
  SCOPE: env['VITE_SCOPE'],
  IS_RUNNING_STAND_ALONE: env['VITE_IS_RUNNING_STAND_ALONE'] === 'true',
  ACCESS_TOKEN_STORAGE_KEY: env['VITE_ACCESS_TOKEN_KEY'],
  USER_STORAGE_KEY: env['VITE_USER_STORAGE_KEY'],
  PROFILES_API_URL: env['VITE_PROFILES_API_URL'],
  FEDERATIONS_API_URL: env['VITE_FEDERATIONS_API_URL'],
  MOCK_API_ENABLED: env['VITE_MOCK_API_ENABLED'],
  IS_DOMAIN_FEDERATION_ENABLED: env['VITE_DOMAIN_FEDERATION_ENABLED'] === 'true',
  HANDLE_UNAUTHORIZED_API_ERROR: env['VITE_HANDLE_UNAUTHORIZED_API_ERROR'] === 'true',
  SHOW_AUTHENTICATION_SETTINGS: env['VITE_SHOW_AUTHENTICATION_SETTINGS'] === 'true',
  IS_DATA_REGION_ENABLED: env['VITE_DATA_REGION_ENABLED'] === 'true',
  IS_SAML_LOGOUT_ENABLED_ENABLED: env['VITE_SAML_LOGOUT_ENABLED'] === 'true',
  IS_SAML_LOGOUT_REQUEST_SIGNED_ENABLED: env['VITE_SAML_LOGOUT_REQUEST_SIGNED_ENABLED'] === 'true',
  IS_FEDERATION_INFO_NEW_SIGN_IN_REVIEW_ENABLED: env['VITE_FEDERATION_INFO_NEW_SIGN_IN_REVIEW_ENABLED'] === 'true',
  IS_ACCOUNT_MODAL_ENABLED: env['VITE_ACCOUNT_MODAL_ENABLED'] === 'true',
  FEDERATION_API_KEY: env['VITE_FEDERATION_API_KEY'],
  ACCOUNT_MASTER_API_URL: env['VITE_ACCOUNT_MASTER_API_URL'],
  RESET_PASSWORDS_API_URL: env['VITE_RESET_PASSWORDS_API_URL'],
  UNLOCK_ACCOUNTS_API_URL: env['VITE_UNLOCK_ACCOUNTS_API_URL'],
  IS_PRODUCTION: env['PROD'],
  TEST_EMAIL_CALLBACK_US: env['VITE_TEST_EMAIL_CALLBACK_US'],
  TEST_EMAIL_CALLBACK_EU: env['VITE_TEST_EMAIL_CALLBACK_EU'],
  TEST_EMAIL_CALLBACK_UK: env['VITE_TEST_EMAIL_CALLBACK_UK'],
  TEST_EMAIL_CALLBACK_AU: env['VITE_TEST_EMAIL_CALLBACK_AU'],
  TID_FEDERATION_CONFIGURATION_INPUT_GUIDE_URL: env['VITE_TID_FEDERATION_CONFIGURATION_INPUT_GUIDE_URL'],
  IAM_ACCOUNTS_API_URL: env['VITE_IAM_ACCOUNTS_API_URL'],
  GET_ACCESS_TOKEN: localStorage.getItem('accessToken') || '',
};
